import Loaderimg from "./Assets/Images/loader.gif";
const Logo =
  "https://jusride.s3.ap-south-1.amazonaws.com/appfiles/justridenamelogo.png";
// const BASE_URL_API = `http://52.66.249.248:3005/api/`
// const BASE_URL_API = `http://127.0.0.1:3005/api/`;
const BASE_URL_API = () => {
const url ="https://uat-api.jusride.info/api/"
// const url ="http://127.0.0.1:3005/api/"
  // SSR / build-time safety
  if (typeof window === "undefined") {
    return url;
  }

  
  const isLocal = localStorage.getItem("isLocal");

  if (isLocal == 1) {
    return url;
  }
  else if (isLocal == 2) {
    // return "https://pgb360xx-3005.inc1.devtunnels.ms/api/";
    return url;
  }

  return url;
};
//const BASE_URL_API = `https://api.wattawow.com/api/`
//  const BASE_URL_API = `https://prod.jusride.com/api/`;
// const BASE_URL_API = `https://preprod.wattawow.com/api/`;
// const BASE_URL_API = `https://prod.jusride.com/api/`;
//  const BASE_URL_API = `https://52.66.244.185/api/`
const amc_redirect_url = "https://admin.jusride.com/";

const roles = [
  { id: "67b305bdbcc940b12f2366cf", role: "Home Technician" },
  { id: "67b305d4bcc940b12f2366d1", role: "Store Technician" },
  { id: "67b3060abcc940b12f2366d3", role: "Pick-Up/Drop Person" },
];
const seviceStatuses = {
  newRequest: "NEW",
  acceptedRequest: "ACCEPTED",
  inProgress: "IN-PROGRESS",
  completed: "COMPLETED",
  delivered: "DELIVERED",
};
const environment = "PRODUCTION"

// const newRequest ="NEW"
// const acceptedRequest ="ACCEPTED"
// const inProgress ="IN-PROGRESS"
// const newRequest ="COMPLETED"
// const newRequest ="DELIVERED"
export {
  Loaderimg,
  Logo,
  BASE_URL_API,
  roles,
  amc_redirect_url,
  seviceStatuses,
  environment
};
